import { createAction, props } from '@ngrx/store';

export const optimizelyLoaded = createAction(
  '[Optimizely loaded] Optimizely loaded',
  props<{ payload: boolean }>()
);

export type OptimizelyActions = typeof optimizelyLoaded;
